const BASE_URL = process.env.REACT_APP_REACT_APP_BASE_URL;

const ASSET_URL = process.env.REACT_APP_REACT_APP_ASSET_URL;

const AUTH_URL = "";

const config = {
  baseUrl: BASE_URL,
  authUrl: AUTH_URL,
  assetUrl: ASSET_URL,
  endPoints: {
    utils: {
      fileUpload: (type: string) => `/utils/upload?type=${type}`,
      deleteFile: `/utils/upload`,
    },
    patient: {
      add: "/patient",
      addReferral: (patientId: string) => `/patient/re-refer/${patientId}`,
      update: (id: string) => `/patient/${id}`,
      delete: (id: string) => `/patient/${id}`,
      getById: (id: string) => `/patient/${id}`,
      search: (pageNo: number, pageSize: number) =>
        `/patient/search?page=${pageNo + 1}&perPage=${pageSize}`,
      getFilter: `/patient/get-filters`,
      canUpdate: (submittedAt: string) =>
        `/patient/canupdate?submittedAt=${submittedAt}`,
      exportCSV: (type: string, from: string, to: string) =>
        `/patient/report?type=${type}&from=${from}&to=${to}`,
    },
    disease: {
      getAll: "/disease",
      add: `/disease/`,
      update: (id: string) => `/disease/${id}`,
      delete: (id: string) => `/disease/${id}`,
      getById: (id: string) => `/disease/${id}`,
    },
    department: {
      getAll: "/department",
      add: `/department/`,
      update: (id: string) => `/department/${id}`,
      delete: (id: string) => `/department/${id}`,
      getById: (id: string) => `/department/${id}`,
    },
    user: {
      addUser: "/users",
      searchUsers: (pageNo: number, pageSize: number) =>
        `/users/search?page=${pageNo + 1}&perPage=${pageSize}`,
      update: (id: string) => `/users/${id}`,
      delete: (id: string) => `/users/${id}`,
      getMe: `/users/me`,
      getById: (id: string) => `/users/${id}`,
      changePassword: `/users/update-password`,
      verify: `/users/verify-link`,
    },
    auth: {
      token: "/token", // NOTE: Not used
      logout: "/logout", // NOTE: Not used
      login: "/users/signin",
      forgetPass: `/users/forgot-password`,
      me: "/users/me",
    },
    bed: {
      get: "/bed",
      create: `/bed`,
      update: (type: string) => `/bed/${type}`,
    },
  },
};

export default config;
